import React from "react";
import { Col, Row } from "react-bootstrap";
import "./rosette.css";

const RosetteResearher = ({
  idx,
  text,
  color,
  count,
  countTitle,
  icon,
  hoverable,
}) => {
  return (
    <div className="text-white p-2">
      <Row
        className="mb-0 rounded-lg border rounded-bottom"
        id={hoverable ? "rosette-wrapper" : ""}
        style={{
          backgroundColor: color,
        }}
      >
        <Col className="col-12 my-3">
          <Row className="align-items-center mb-0">
            <Col className="col-2 text-lg">
              <h2>{idx + 1}</h2>
            </Col>
            <Col
              className="col-10"
              style={{
                maxHeight: "40px",
              }}
            >
              <h6 className="">{text}</h6>
            </Col>
          </Row>
        </Col>

        <Col className="col-12 mb-3">
          <Row className="justify-content-center mb-0">
            <Col className="col-7">
              <img
                style={{
                  height: "40px",
                  width: "100%",
                  objectFit: "contain",
                }}
                src={icon}
              ></img>
            </Col>
          </Row>
        </Col>

        {count && (
          <Col className="col-12 rounded-bottom">
            <Row
              className="justify-content-center mb-0 bg-light py-2 "
              style={{ color: color }}
            >
              <Col className="col-8 text-center  rounded-bottom">
                <h4 className="font-weight-bold">{count}</h4>
                <h6 className="nowrap">{countTitle}</h6>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default RosetteResearher;
